import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { X, Heart, Briefcase, User, Brain, Sparkles } from 'lucide-react';
import './WelcomeModal.css';

function WelcomeModal({ isOpen, onClose }) {
  const { user, linkSessionReadings } = useAuth();
  const [isLinking, setIsLinking] = useState(false);

  if (!isOpen) return null;

  const handleLinkReadings = async () => {
    const sessionId = localStorage.getItem('sessionId');
    if (sessionId) {
      try {
        setIsLinking(true);
        await linkSessionReadings(sessionId);
        // Session readings linked successfully
        onClose();
      } catch (error) {
        console.error('Failed to link session readings:', error);
      } finally {
        setIsLinking(false);
      }
    } else {
      onClose();
    }
  };

  const sessionId = localStorage.getItem('sessionId');
  const hasSessionReadings = sessionId && sessionId !== 'new-user';

  return (
    <div className="welcome-modal-overlay">
      <div className="welcome-modal">
        <button className="welcome-modal-close" onClick={onClose}>
          <X size={24} />
        </button>
        
        <div className="welcome-content">
          <div className="welcome-header">
            <Sparkles className="welcome-icon" size={48} />
            <h1>Welcome to your Tarot Journey, {user?.firstName}!</h1>
            <p>Your personal space for tarot wisdom and spiritual growth</p>
          </div>

          {hasSessionReadings && (
            <div className="session-link-section">
              <h3>Link Your Previous Readings</h3>
              <p>We found some readings from your previous session. Would you like to add them to your account?</p>
              <button 
                className="link-button" 
                onClick={handleLinkReadings}
                disabled={isLinking}
              >
                {isLinking ? 'Linking...' : 'Yes, Link My Readings'}
              </button>
              <button className="skip-button" onClick={onClose}>
                Skip for Now
              </button>
            </div>
          )}

          <div className="getting-started">
            <h3>Let's Get Started</h3>
            <div className="spread-options">
              <Link to="/love-spread" className="spread-card" onClick={onClose}>
                <Heart className="spread-icon" />
                <h4>Love & Relationships</h4>
                <p>Explore matters of the heart</p>
              </Link>
              
              <Link to="/career-spread" className="spread-card" onClick={onClose}>
                <Briefcase className="spread-icon" />
                <h4>Career & Purpose</h4>
                <p>Discover your professional path</p>
              </Link>
              
              <Link to="/personal-growth-spread" className="spread-card" onClick={onClose}>
                <User className="spread-icon" />
                <h4>Personal Growth</h4>
                <p>Unlock your inner potential</p>
              </Link>
              
              <Link to="/mental-healing-spread" className="spread-card" onClick={onClose}>
                <Brain className="spread-icon" />
                <h4>Mental Healing</h4>
                <p>Find peace and clarity</p>
              </Link>
            </div>
          </div>

          <div className="welcome-footer">
            <p>You can always access your readings from the <Link to="/diary" onClick={onClose}>My Diary</Link> section</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WelcomeModal;
